export const categoryData = {
  dress: {
    name: '예복',
    nameEn: 'Dress',
    color: '#1a2744',
    lightColor: '#2a3f5f',
    description: '대여·맞춤·반수제·수제',
    icon: 'ri-shirt-line',
  },
  jewelry: {
    name: '예물',
    nameEn: 'Jewelry',
    color: '#a88245',
    lightColor: '#c9a96e',
    description: '커플링·다이아 반지',
    icon: 'ri-vip-diamond-line',
  },
  hanbok: {
    name: '한복',
    nameEn: 'Hanbok',
    color: '#c0ac94',
    lightColor: '#d5c5b0',
    description: '신랑신부·혼주',
    icon: 'ri-flower-line',
  },
};

export const statusLabels: Record<string, { label: string; color: string; badgeColor: string }> = {
  not_started: { label: '미진단', color: '#9ca3af', badgeColor: '#f3f4f6' },
  browsing: { label: '탐색 중', color: '#c9a96e', badgeColor: '#fdf8f0' },
  has_candidate: { label: '후보 있음', color: '#2a3f5f', badgeColor: '#eef2f7' },
  consultation: { label: '상담 예정', color: '#a88245', badgeColor: '#fdf8f0' },
  contracted: { label: '계약 완료', color: '#16a34a', badgeColor: '#f0fdf4' },
};